import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo } from 'react';
import CtaGroup from './components/CtaGroup';
import LinkGroup from './components/LinkGroup';
import { IMyBusinessProps } from './MyBusiness.interfaces';
import useStyles from './MyBusiness.styles';

const MyBusiness = ({ title, links, powerAppsCtas = [], MaxCtaColumns = 4 }: IMyBusinessProps) => {
  const classes = useStyles();
  const maxColumns = powerAppsCtas.length > MaxCtaColumns ? MaxCtaColumns : powerAppsCtas.length;

  return (
    <div className={clsx('my-bussiness', classes.root)}>
      <div className={classes.headerWrap}>
        <MuiTypography variant="h4" component="h4" className={classes.title}>
          {title}
        </MuiTypography>
        {links && <LinkGroup links={links} />}
      </div>
      <div className={classes.bodyWrap}>
        <CtaGroup ctas={powerAppsCtas} columns={maxColumns} />
      </div>
    </div>
  );
};

export default memo(MyBusiness);
